export const SAVE_MASTERS = 'SAVE_MASTERS'
export const UPDATE_SAVED_INPUT = 'UPDATE_SAVED_INPUT'
export const SET_USER_SETTINGS = 'SET_USER_SETTINGS'
